import React, { useState } from "react";

import { useMutation } from "@apollo/client";
import { NextSeo } from "next-seo";
import toast from "react-hot-toast";

import { SUBMIT_FORM_JSON_GQL } from "../../apollo-graphql/mutation";
import MainLayout from "../../components/MainLayout";
import BusinessContactView from "../../views/BusinessContactView";

export default function Page() {
  const [submitted, setSubmitted] = useState();

  const onError = () => {
    toast.error("對不起，您的資料暫時未能提交，請稍後重新提交");
  };

  const [gqlSubmit, { loading }] = useMutation(SUBMIT_FORM_JSON_GQL, {
    onCompleted: (data) => {
      if (data?.submitFormJson) {
        setSubmitted(true);
      } else {
        onError("Unknown error");
      }
    },
    onError,
  });

  return (
    <>
      <NextSeo title="委託合作" />
      <BusinessContactView
        loading={loading}
        onFormDirtyChanged={(isDirty) => isDirty && setSubmitted(false)}
        onSubmit={(data) =>
          gqlSubmit({
            variables: {
              data: JSON.stringify(data),
              formName: "business-enquiry-form",
            },
          })
        }
        submitted={submitted}
      />
    </>
  );
}

Page.getLayout = function getLayout(page) {
  return <MainLayout>{page}</MainLayout>;
};

export const getStaticProps = async () => ({
  props: {},
  revalidate: 86400,
});
